import * as React from "react";

function SvgGeneral(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M23.071 10.42C22.077 4.297 19.732 0 17.003 0c-2.728 0-5.073 4.298-6.067 10.42H23.07zM10.421 17c0 1.522.083 2.982.227 4.387h12.704A42.95 42.95 0 0023.578 17a42.95 42.95 0 00-.226-4.387H10.648A42.95 42.95 0 0010.422 17zm22.263-6.58A17.038 17.038 0 0021.85.712c1.673 2.317 2.825 5.806 3.428 9.706h7.405zM12.149.712a17.027 17.027 0 00-10.826 9.706h7.405c.596-3.9 1.748-7.39 3.421-9.706zm21.268 11.9h-7.864c.144 1.44.226 2.913.226 4.387 0 1.474-.082 2.948-.226 4.387h7.857A16.85 16.85 0 0034 17c0-1.522-.212-2.982-.583-4.387zM8.227 17c0-1.474.083-2.948.227-4.387H.59A17.147 17.147 0 000 17c0 1.522.22 2.982.59 4.387h7.857A46.408 46.408 0 018.227 17zm2.709 6.58C11.93 29.703 14.275 34 17.003 34c2.73 0 5.074-4.298 6.068-10.42H10.936zm10.922 9.707a17.054 17.054 0 0010.832-9.706h-7.404c-.604 3.9-1.755 7.39-3.428 9.706zM1.323 23.581a17.038 17.038 0 0010.833 9.706c-1.673-2.317-2.825-5.806-3.428-9.706H1.323z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgGeneral;
